import styled from 'styled-components';

import { LandingHero } from 'constants/landing-hero';

export const Tag = styled.div<{ $tone: 'success' | 'neutral' }>`
  background: ${({ $tone }) =>
    $tone === 'success' ? LandingHero.successPillBg : LandingHero.chipBg};
  color: ${({ $tone }) =>
    $tone === 'success' ? LandingHero.successPillText : LandingHero.chipText};
  border: 0.1rem solid
    ${({ $tone }) =>
      $tone === 'success'
        ? LandingHero.pro.chipHoverBorder
        : LandingHero.chipBorder};
  border-radius: 999rem;
  padding: 0.7rem 1.4rem;
  font-size: 1.3rem;
  font-weight: 800;
  white-space: nowrap;
`;
